<template>
    <div class="section-box">
        <div v-loading="listLoading">
            <el-form label-width="90px">
                <el-form-item label="角色编号：">
                    <el-input size="medium" v-model="roleCode" disabled placeholder="请输入菜单名称" type="text" />
                </el-form-item>
                <el-form-item label="角色名称：">
                    <el-input size="medium" v-model="roleName" disabled placeholder="请输入菜单名称" type="text" />
                </el-form-item>
                <el-form-item label="菜单：">
                    <div class="box-tree">
                        <el-tree
                            :data="menuList"
                            show-checkbox
                            default-expand-all
                            node-key="NodeID2"
                            ref="tree"
                            highlight-current
                            :props="defaultProps">
                        </el-tree>
                    </div>
                </el-form-item>
                <el-form-item label=" ">
                    <el-button size="medium" type="primary" @click="confirmMenu" :loading="confirmLoading">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import {
    actionTreeList,            //获取角色tree
    setRoleAction,          //提交角色tree
} from "@/service/system";
  export default {
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if(!vm.$route.query.roleId) {
          vm.$message.warning('缺少角色id')
          setTimeout(() => {
            vm.removeTabList({
              id: vm.$route.meta.menuId,
            })
            vm.$router.push('/system/roleConfig')
          }, 300)
        }else{
          vm.roleId = vm.$route.query.roleId
          vm.GetActionTreeList()
        }
      })
    },

    data() {
      return {
        listLoading: false,
        confirmLoading: false,
        roleId: '',     //上一级待过来的
        roleCode: '',
        roleName: '',

        menuList: [],
        defaultProps: {
          children: 'ChildTreeNodeList',
          label: 'NodeName'
        }
      };
    },
    methods:{
      ...mapActions('app', [
        'removeTabList'
      ]),
      //获取角色信息 tree
      async GetActionTreeList(){
        this.listLoading = true
        let data = {}
        data.AppId = 1;
        data.RoleId = this.roleId
        data.platform = 'pcweb'
        let res = await actionTreeList(data)
        this.listLoading = false
        if(res.Result != 1) {
          return this.$message.error('获取失败请联系开发人员')
        }
        this.roleCode = res.Data.RoleCode
        this.roleName = res.Data.RoleName
        this.menuList = res.Data.TreeNodeList
        // console.log('res.Data.SelectTreeNodeIdList:'+JSON.stringify(res.Data.SelectTreeNodeIdList));
        this.$refs.tree.setCheckedKeys(res.Data.SelectTreeNodeIdList);
      
      },
      confirmMenu(){
        let data = {}
        data.RoleID = this.roleId
        let actionIdList = this.$refs.tree.getCheckedNodes()
        let arr = []
        actionIdList.map(obj=>{
          if(obj.NodeType == 2) {
            arr.push(obj.NodeID)
          }
        })
        data.actionIdList = arr
        data.AppId = 1
        data.platform = 'pcweb'
        this.confirmLoading = true
        setRoleAction(data).then(res=>{
          this.confirmLoading = false
          if(res.Result != 1) {
            return this.$message.error(res.Message)
          }
          this.$message.success(res.Message)
          setTimeout(() => {
            this.removeTabList({
              id: this.$route.meta.menuId,
            })
            this.$router.push('/system/roleConfig')
          }, 300)
        })
      }
    },
  };
</script>
<style lang="scss">
    .box-tree {
        border: 1px solid #ebebeb;
        min-height: 580px;
        padding: 20px;
    }
</style>